var _tspan, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 29,
    viewBox: "0 0 226.643 63.183",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    style: {
      InkscapeFontSpecification: "Unispace"
    },
    x: 94.176,
    y: 68.328,
    transform: "matrix(.87838 0 0 1.13846 -16.823 -15.434)",
    fontWeight: 400,
    fontSize: 43.375,
    fontFamily: "Unispace",
    fill: "#fff",
    strokeWidth: 0.301
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 94.176,
    y: 68.328
  }, "CROPDAI"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.175,
    d: "M1.587 1.588h60.008v60.008H1.587z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4.233,
    d: "M23.616 23.869h36.967v36.967H23.616z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/headerLogo.d59f6f5bddbd3e07d9c71cfee9be331f.svg";
export { ForwardRef as ReactComponent };